import { Component, OnInit, Input, Inject } from '@angular/core'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'environments/environment';

@Component({
  standalone: false,
  selector: 'app-video-dialog',
  templateUrl: './video-dialog.component.html',
  styleUrls: ['./video-dialog.component.scss']
})
export class VideoDialogComponent implements OnInit {
  public title: string
  public trustedUrl: SafeUrl;
  public domainName: string;

  constructor(
    public dialogRef: MatDialogRef<VideoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer
  ) {
    this.title = this.data.title
  }

  ngOnInit() {
    this.trustedUrl = this.getTrustedUrl();
  }

  getTrustedUrl(): SafeUrl {
    const newUrl = this.getEmbedUrl();
    if (newUrl) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(newUrl);
    }
    return null;
  }

  getEmbedUrl(): string {
    if (this.data.videoUrl) {
      if (this.testDvidsHubUrl(this.data.videoUrl)) {
        this.domainName = 'dvidshub';
        return 'https://www.dvidshub.net/video/embed/' + this.data.videoId;
      } else if (this.testYoutubeUrl(this.data.videoUrl)) {
        this.domainName = 'youtube';
        return 'https://www.youtube.com/embed/' + this.data.videoId.trim();
      } else if (this.testVimeoUrl(this.data.videoUrl)) {
        this.domainName = 'vimeo';
        return 'https://player.vimeo.com/video/' + this.data.videoId.trim();
      }
    }
    return this.data.videoUrl;
  }

  testDvidsHubUrl(url: string): boolean {
    const dvidsHubpathRegex: RegExp = /(dvidshub.net).*\/(\d+(?!=\/))/;
    return dvidsHubpathRegex.test(url);
  }

  testYoutubeUrl(url: string): boolean {
    const youtubePathRegex: RegExp = /www.youtube.com\/(watch\?v\=)(\S+)/;
    return youtubePathRegex.test(url);
  }

  testVimeoUrl(url: string): boolean {
    const vimeoPathRegex: RegExp = /vimeo.com\/(\S+)/;
    return vimeoPathRegex.test(url);
  }
}
